import {
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import S3Image from "../../../component/S3Image";
import TextArea from "antd/es/input/TextArea";
import axios from "../../../config/axiosInstance";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { uploadPodcast } from "../../../config/s3config/s3fileUpload";
import { API } from "../../../config/API";
import PageHeader from "../../../component/pageHeaders";
import ImagePicker2 from "../../../component/image-pickersecond";
import { LoadTags } from "../../../utils/commonapis";
import { IoCloudUploadOutline, IoCloseCircleOutline } from "react-icons/io5";

const { Text } = Typography;

const PodcastForm = (props: any) => {
  const User = useSelector((state: any) => state.User.user);
  const [form] = Form.useForm();
  const [tags, setTags] = useState<any>([]);
  const [imageurl, setImageurl] = useState(
    props.items?.id ? props.items?.attributes?.image || "" : "",
  );
  const [isUploading, setIsUploading] = useState<any>(false);
  const [loading, setLoading] = useState(false);
  const [imageUploader, setImageUploader] = useState(false);
  const [tagFilter, setTagFilters] = useState("");
  const [loading3, setLoading3] = useState(true);

  const isEditMode = !!(props.items && props.items.id);

  useEffect(() => {
    loadTags(tagFilter);
  }, [tagFilter]);

  const loadTags = async (searchTerm: any) => {
    setLoading3(true);
    try {
      const res: any = await LoadTags(searchTerm);
      setTags(res);
    } catch (error) {
    } finally {
      setLoading3(false);
    }
  };

  function debounce(func: any, delay: any) {
    let timer: any;
    return (...args: any) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }

  const OnTagSearch = debounce((value: any) => {
    setTagFilters(value);
  }, 200);

  const handleSubmit = async (values: any, isDraft: boolean = false) => {
    setLoading(true);
    let requestObj = {
      data: {
        title: values.head,
        body: values.body,
        audio: values.link,
        tags: values.tags,
        permalink: values.permalink,
        image:
          props.items.id && props.items.attributes.image
            ? props.items.attributes.image
            : imageurl,
        user: isEditMode ? props.items?.attributes?.user?.data?.id : User?.id,
        publishedAt: isDraft ? null : new Date().toISOString(),
      },
    };
    let url =
      props.items && props.items.id
        ? API.BASE_URL + API.PODCAST + `/${props.items.id}`
        : API.BASE_URL + API.PODCAST;

    let method = props.items && props.items.id ? "PUT" : "POST";
    axios({
      method: method,
      url: url,
      data: requestObj,
    })
      .then(() => {
        setLoading(false);
        props.onClose();
        message.success(
          isDraft
            ? "Podcast saved as draft"
            : isEditMode
              ? "Podcast updated"
              : "Podcast published",
        );
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        message.error("Something went wrong");
      });
  };

  const onFinish = async (values: any) => {
    await handleSubmit(values, false);
  };

  const handleSaveDraft = async () => {
    try {
      const values = await form.validateFields();
      await handleSubmit(values, true);
    } catch {
      // validation failed
    }
  };

  const onImageUpload = async (val: any) => {
    setIsUploading(true);
    const response: any = await uploadPodcast(val);
    if (response) {
      setImageurl(response?.data?.imageUrl);
      setIsUploading(false);
    }
  };

  const addImageToList = async (val: any) => {
    if (val?.type === "medialibrary") {
      setImageurl(val?.val);
    } else {
      await onImageUpload(val?.val?.file);
    }
  };

  return (
    <>
      <PageHeader
        title={isEditMode ? "Edit Podcast" : "Create Podcast"}
        onBack={() => props.onClose()}
      />
      <div
        style={{
          padding: "16px 24px",
          maxHeight: "calc(100vh - 70px)",
          overflowY: "auto",
        }}
      >
        <Row gutter={24}>
          <Col xs={24} lg={14}>
            <Card
              title="Podcast Details"
              size="small"
              headStyle={{ fontSize: 14 }}
            >
              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                name="add-podcast"
                initialValues={{
                  head: props.items?.attributes?.title,
                  body: props.items?.attributes?.body,
                  link: props.items?.attributes?.audio,
                  permalink: props.items?.attributes?.permalink,
                  tags: props.items?.attributes?.tags?.data?.map(
                    (item: any) => item?.id,
                  ),
                }}
              >
                <Form.Item
                  label="Title"
                  name="head"
                  rules={[{ required: true, message: "Please enter a title" }]}
                >
                  <Input size="large" placeholder="Enter podcast title" />
                </Form.Item>

                <Form.Item label="Description" name="body">
                  <TextArea
                    rows={5}
                    placeholder="Enter podcast description..."
                    showCount
                  />
                </Form.Item>

                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="Audio / Video Link"
                      name="link"
                      rules={[
                        {
                          required: true,
                          message: "Please enter podcast link",
                        },
                      ]}
                    >
                      <Input
                        size="large"
                        placeholder="https://youtube.com/..."
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item label="Permalink" name="permalink">
                      <Input size="large" placeholder="podcast-slug" />
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item label="Tags" name="tags">
                  <Select
                    mode="multiple"
                    placeholder="Search and select tags"
                    size="large"
                    filterOption={(input: any, option: any) =>
                      option?.children
                        ?.toLowerCase()
                        ?.indexOf(input.toLowerCase()) >= 0
                    }
                    loading={loading3}
                    onSearch={(val) => OnTagSearch(val)}
                  >
                    {tags.length > 0 &&
                      tags.map((item: any) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.tag}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>

                <Divider />

                <Form.Item>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 8,
                    }}
                  >
                    <Button size="large" onClick={() => props.onClose()}>
                      Cancel
                    </Button>
                    <Button
                      size="large"
                      onClick={handleSaveDraft}
                      loading={loading}
                      disabled={isUploading}
                    >
                      Save as Draft
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      size="large"
                      loading={loading}
                      disabled={isUploading}
                    >
                      {isEditMode ? "Update & Publish" : "Publish"}
                    </Button>
                  </div>
                </Form.Item>
              </Form>
            </Card>
          </Col>

          <Col xs={24} lg={10}>
            <Card
              title="Cover Image"
              size="small"
              headStyle={{ fontSize: 14 }}
            >
              {imageurl ? (
                <div style={{ position: "relative" }}>
                  <S3Image
                    src={imageurl}
                    style={{
                      width: "100%",
                      maxHeight: 280,
                      objectFit: "cover",
                      borderRadius: 8,
                    }}
                    alt="Podcast cover"
                  />
                  <Button
                    type="text"
                    danger
                    size="small"
                    icon={<IoCloseCircleOutline size={18} />}
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      background: "rgba(255,255,255,0.85)",
                      borderRadius: "50%",
                      width: 32,
                      height: 32,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() => setImageurl("")}
                  />
                  <div style={{ marginTop: 12 }}>
                    <Button
                      block
                      onClick={() => setImageUploader(true)}
                      loading={isUploading}
                    >
                      Change Image
                    </Button>
                  </div>
                </div>
              ) : (
                <div
                  onClick={() => setImageUploader(true)}
                  style={{
                    border: "2px dashed #d9d9d9",
                    borderRadius: 8,
                    padding: "40px 20px",
                    textAlign: "center",
                    cursor: "pointer",
                    background: "#fafafa",
                    transition: "border-color 0.3s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.borderColor = "#1890ff")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.borderColor = "#d9d9d9")
                  }
                >
                  {isUploading ? (
                    <div>
                      <Text type="secondary">Uploading...</Text>
                    </div>
                  ) : (
                    <>
                      <IoCloudUploadOutline
                        size={40}
                        color="#bbb"
                        style={{ marginBottom: 8 }}
                      />
                      <div>
                        <Text type="secondary">
                          Click to upload cover image
                        </Text>
                      </div>
                    </>
                  )}
                </div>
              )}
            </Card>
          </Col>
        </Row>
      </div>

      {imageUploader ? (
        <ImagePicker2
          onSubmit={(val: any) => addImageToList(val)}
          visible={imageUploader}
          close={() => setImageUploader(false)}
        />
      ) : null}
    </>
  );
};

export default PodcastForm;
